/**
 * Carting point addresses and contact persons, shared by the screens that show them (Send Tariff copy text,
 * Weekly Consol planning template). Each value is a single string, one line per row.
 * To add another carting point, add its strings below the same way.
 */
export class CartingPoints {

  // JWR CFS
  public static readonly JWR_CFS_ADDRESS: string = [
    'GRT Carting Point — JWR CFS',
    'JWR LOGISTICS PVT LTD',
    'A/C – GRT Global Logistics Pvt Ltd',
    'Shed A / Bay No.: A-10 & A-11'
  ].join('\n');

  public static readonly JWR_CFS_CONTACTS: string = [
    'Sahil Patil — 98200 22091',
    'Ramesh Ankush Dhakarke — 98703 39026'
  ].join('\n');

}
